import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { RadioButtonComponent } from '@adaptiva/widgets/radio-button';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { TimeScaleComponentModule } from '@adaptiva/widgets/time-scale';
import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { TrackingPropertiesComponent } from './tracking-properties.component';

const WIDGETS: Type<any>[] = [
	AuthoringPropertyLabelComponentModule,
	CardComponentModule,
	ContainerComponentModule,
	InputComponentModule,
	RadioButtonComponent,
	TextComponentModule,
	TimeScaleComponentModule
];

@NgModule({
	imports: [
		CommonModule,
		DisplayAuthoringPropertyPipe,
		IsRequiredPropertyPipe,
		InheritPipe,
		...WIDGETS
	],
	declarations: [TrackingPropertiesComponent],
	exports: [TrackingPropertiesComponent]
})
export class TrackingPropertiesComponentModule {

}
